/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Form_Submit_SendingInputs */

const tr_contact_form_submit_sending = /** @type {(inputs: Contact_Form_Submit_SendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gönderiliyor…`)
};

const en_contact_form_submit_sending = /** @type {(inputs: Contact_Form_Submit_SendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sending…`)
};

const de_contact_form_submit_sending = /** @type {(inputs: Contact_Form_Submit_SendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wird gesendet…`)
};

const ru_contact_form_submit_sending = /** @type {(inputs: Contact_Form_Submit_SendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отправка…`)
};

/**
* | output |
* | --- |
* | "Sending…" |
*
* @param {Contact_Form_Submit_SendingInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const contact_form_submit_sending = /** @type {((inputs?: Contact_Form_Submit_SendingInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Form_Submit_SendingInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_contact_form_submit_sending(inputs)
	if (locale === "de") return de_contact_form_submit_sending(inputs)
	if (locale === "ru") return ru_contact_form_submit_sending(inputs)
	return tr_contact_form_submit_sending(inputs)
});